@if (isBusy()) {
  <span class="d-inline-block placeholder placeholder-wave bg-gray-400 rounded"
    style="width: 1.75rem; height: 1.75rem; vertical-align: middle;"
    title="Procesando..."></span>
} @else {
  <button type="button" class="btn btn-outline-success btn-xs"
      (click)="triggerClick(fileInput)"
      title="Subir Documento">
    <i class="fas fa-upload"></i>
  </button>
}
<input type="file" #fileInput style="display: none;"
    (change)="onFileSelected($event)" accept=".pdf,image/*">
